<!-- Loading Skeleton -->
<div *ngIf="loading" class="w-full h-full flex items-center justify-center">
    <div class="text-center">
        <mat-spinner class="m-auto" [diameter]="36" [color]="'primary'"></mat-spinner>
        <div class="mt-5">
            <span class="text-gray-600 font-inter text-[14px]">Carregando dados...</span>
        </div>
    </div>
</div>

<!-- Content -->
<div *ngIf="!loading" class="w-full overflow-y-auto h-full">
    <div class="w-full p-2">
        <!-- Avatar e Nome -->
        <ng-container>
            <div class="grid sm:grid-cols-1 w-full">
                <div class="col-span-1 m-2">
                    <div class="w-full rounded-xl">
                        <div class="flex w-full">
                            <div class="rounded-l-xl p-4 bg-gray-200">
                                <div class="rounded-full pt-[3px]">
                                    <div class="w-14 h-14 relative my-auto" *ngIf="userData?.details?.avatar">
                                        <img class="w-14 h-14 object-cover rounded-full" [src]="userData?.details?.avatar" />
                                    </div>
                                    <div class="w-14 h-14 relative my-auto flex items-center justify-center bg-gray-300 rounded-full" *ngIf="!userData?.details?.avatar">
                                        <mat-icon class="icon-size-8 text-gray-500" [svgIcon]="'mat_outline:person'"></mat-icon>
                                    </div>
                                </div>
                            </div>
                            <div class="rounded-r-xl w-full p-4 flex bg-gray-100">
                                <div class="flex flex-col">
                                    <span class="pt-2 font-remote font-[700] text-[20px] text-gray-700">{{ userData?.details?.fullName || 'Nome não informado' }}</span>
                                    <span class="text-gray-500 text-[14px] font-inter mt-1">{{ userData?.email || 'Email não informado' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <!-- Dados Pessoais -->
        <ng-container>
            <div class="w-full py-6">
                <div class="flex w-full">
                    <div class="p-2 rounded-xl bg-blue-100 ml-2 h-[40px]">
                        <mat-icon svgIcon="mat_outline:person" class="icon-size-6 text-blue-600"></mat-icon>
                    </div>
                    <div class="px-3">
                        <div class="w-full leading-10">
                            <span class="text-[17px] font-[500] font-remote">Dados pessoais</span>
                        </div>
                    </div>
                </div>
                <div class="w-full p-4">
                    <div class="w-full flex justify-between py-3 border-b border-b-gray-100">
                        <div class="px-2">
                            <span class="font-inter text-gray-900 text-[14px] font-[500]">Sexo</span>
                        </div>
                        <div class="px-2">
                            <span class="font-inter text-gray-400 text-[13px] font-[400]">
                                {{ userData?.details?.gender === 'male' ? 'Masculino' : userData?.details?.gender === 'female' ? 'Feminino' : '-' }}
                            </span>
                        </div>
                    </div>
                    <div class="w-full flex justify-between py-3 border-b border-b-gray-100">
                        <div class="px-2">
                            <span class="font-inter text-gray-900 text-[14px] font-[500]">Data de nascimento</span>
                        </div>
                        <div class="px-2">
                            <span class="font-inter text-gray-400 text-[13px] font-[400]">{{ userData?.details?.birthday ? (userData.details.birthday | mask: '00/00/0000') : '-' }}</span>
                        </div>
                    </div>
                    <div class="w-full flex justify-between py-3 border-b border-b-gray-100">
                        <div class="px-2">
                            <span class="font-inter text-gray-900 text-[14px] font-[500]">Cargo/Função</span>
                        </div>
                        <div class="px-2">
                            <span class="font-inter text-gray-400 text-[13px] font-[400]">{{ userData?.details?.title ? userData.details.title : '-' }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Contato e Endereço -->
            <div class="w-full py-6">
                <div class="flex w-full">
                    <div class="p-2 rounded-xl bg-blue-100 ml-2 h-[40px]">
                        <mat-icon svgIcon="mat_outline:location_on" class="icon-size-6 text-blue-600"></mat-icon>
                    </div>
                    <div class="px-3">
                        <div class="w-full leading-10">
                            <span class="text-[17px] font-[500] font-remote">Contato e endereço</span>
                        </div>
                    </div>
                </div>
                <div class="w-full p-4">
                    <div class="w-full flex justify-between py-3 border-b border-b-gray-100">
                        <div class="px-2">
                            <span class="font-inter text-gray-900 text-[14px] font-[500]">Email</span>
                        </div>
                        <div class="px-2">
                            <span class="font-inter text-gray-400 text-[13px] font-[400]">{{ userData?.email ?? '-' }}</span>
                        </div>
                    </div>
                    <div class="w-full flex justify-between py-3 border-b border-b-gray-100">
                        <div class="px-2">
                            <span class="font-inter text-gray-900 text-[14px] font-[500]">Celular</span>
                        </div>
                        <div class="px-2">
                            <span class="font-inter text-gray-400 text-[13px] font-[400]">{{ userData?.details?.phone ? (userData.details.phone | mask: '(00) 00000-0000') : '-' }}</span>
                        </div>
                    </div>
                    <div class="w-full flex justify-between py-3 border-b border-b-gray-100">
                        <div class="px-2">
                            <span class="font-inter text-gray-900 text-[14px] font-[500]">Endereço</span>
                        </div>
                        <div class="px-2 text-right">
                            <span class="font-inter text-gray-400 text-[13px] font-[400]">{{ userData?.details?.address ?? '-' }}</span>
                        </div>
                    </div>
                    <div class="w-full flex justify-between py-3 border-b border-b-gray-100">
                        <div class="px-2">
                            <span class="font-inter text-gray-900 text-[14px] font-[500]">Bairro</span>
                        </div>
                        <div class="px-2">
                            <span class="font-inter text-gray-400 text-[13px] font-[400]">{{ userData?.details?.district ?? '-' }}</span>
                        </div>
                    </div>
                    <div class="w-full flex justify-between py-3 border-b border-b-gray-100">
                        <div class="px-2">
                            <span class="font-inter text-gray-900 text-[14px] font-[500]">Cidade</span>
                        </div>
                        <div class="px-2">
                            <span class="font-inter text-gray-400 text-[13px] font-[400]">{{ userData?.details?.city ?? '-' }}</span>
                        </div>
                    </div>
                    <div class="w-full flex justify-between py-3 border-b border-b-gray-100">
                        <div class="px-2">
                            <span class="font-inter text-gray-900 text-[14px] font-[500]">País</span>
                        </div>
                        <div class="px-2">
                            <span class="font-inter text-gray-400 text-[13px] font-[400]">{{ userData?.details?.country ?? '-' }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
